import { AfterContentInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss'],
})
export class ImageViewComponent implements OnInit, AfterContentInit {

  @Input() imgList = [];
  @Input() index = 0;

  @ViewChild('slides') slides:IonSlides;
  slideOptions = {
    zoom: true,
    initialSlide: 0
  }

  slideStart:boolean = false;

  constructor(
    private modal: ModalController
  ) { }

  ngOnInit() {
    this.slideOptions.initialSlide = this.index;
  }
  ngAfterContentInit() {
    setTimeout(() => {
      this.slideStart = true;
    }, 100);
  }
  dismiss() {
    this.modal.dismiss();
  }
}
